// document.body.addEventListener('click',async (e)=>{
//     if (e.target.closest('button[name="checkout"]') 
//         && window.is_draft_order 
//         && document.querySelector('textarea#gift-note'))
//     {
//         e.preventDefault();
//         e.stopImmediatePropagation();
//         e.stopPropagation();

//         const giftNote = document.querySelector('textarea#gift-note');
//         const formData = new FormData();
//         formData.append(giftNote.name,giftNote.value);
//         await fetch(window.Shopify.routes.root + 'cart/update.js', {
//                 method: 'POST',
//                 body: formData,
//             })
//             .then((res) => res.json())
//             .then((data) => console.log(data))
//         window.hulkappsCheckout();
//     }
// })
document.addEventListener('DOMContentLoaded', () => {
  const giftNoteInput = document.querySelector('#gift-note');
  if (giftNoteInput) {
    giftNoteInput.addEventListener('blur', function() {
      const noteValue = this.value;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          note: noteValue
        })
      })
      .then(response => {
        if (!response.ok) {
          console.error('Error:', response.statusText);
        }
        return response.json(); 
      })
      .then(data => {
        console.log('Cart updated:', data);
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
      });
    });
  }
});
